<template>
  <v-dialog
    transition="dialog-bottom-transition"
    scrollable
    persistent
    max-width="500"
    v-model="dialogModel"
  >
    <v-card v-if="adhocRevenue">
      <v-card-title class="headline grey lighten-2 text-xs-center" primary-title>
        Submit Ad Hoc Revenue
      </v-card-title>
      <div class="pa-2">
        <currency-field
          pb-2
          v-model="adhocRevenue.amount"
          @blur="(val) => adhocRevenue.amount = val"
          :child-props="{ label: 'Amount', disabled: addingAdhocRevenue }"
        />
        <v-text-field
          pb-2
          label="Transaction Date"
          type="date"
          v-model="adhocRevenue.dateCreated"
          :disabled="addingAdhocRevenue"
        />
        <v-text-field
          v-if="isVehicleLocked"
          pb-2
          label="Vehicle"
          :value="lockedVehicle.licensePlateNumber"
          readonly
          disabled
        />
        <v-autocomplete
          v-else
          v-model="adhocRevenue.transportationProfileId"
          :items="vehicles"
          :loading="vehiclesApiInProgress"
          :search-input.sync="adHocVehicleKeywords"
          hide-no-data
          hide-selected
          item-text="licensePlateNumber"
          item-value="id"
          label="Vehicle"
          placeholder="Search by licence plate"
          prepend-icon="fal fa-bus"
          outline
          clearable
        />
        <v-text-field
          pb-2
          :disabled="addingAdhocRevenue"
          v-model="adhocRevenue.notes"
          label="Notes"
        />
        <div class="mb-2">
          <v-text-field
            :disabled="addingAdhocRevenue"
            v-model="adhocRevenue.confirmationId"
            label="Confirmation ID"
            persistent-hint
            hint="(Optional) Can be bank deposit slip number, mobile money transaction ID, etc."
          />
        </div>
      </div>
      <v-divider />
      <v-card-actions>
        <v-btn color="warning" :disabled="addingAdhocRevenue" flat @click="closeDialog">
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn color="primary" :disabled="addingAdhocRevenue || !adhocRevenue.amount || !adhocRevenue.dateCreated || !adhocRevenue.transportationProfileId" :loading="addingAdhocRevenue" @click="saveAdhocRevenue">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import src from './src'
export default src
</script>
